import { useCallback, useEffect, useState } from "react";
import { advanceEligibility } from "../../api/hr";
import { AdvanceForm } from "./AdvanceForm";
import { AdvanceWatermark } from "./AdvanceWatermark";

// بوابة السلف في صفحة راتبي: الاستمارة عند السماح، وعلامة مائية عند إيقاف السلف في الفرع.
export const AdvanceCard = ({ onDone }) => {
  const [rules, setRules] = useState(null);

  const load = useCallback(() => {
    advanceEligibility().then(setRules).catch(() => setRules(null));
  }, []);

  useEffect(load, [load]);

  if (!rules) return null;
  if (!rules.allowed) return <AdvanceWatermark reason={rules.reason} />;

  return (
    <AdvanceForm
      rules={rules}
      onDone={() => {
        load();
        onDone?.();
      }}
    />
  );
};
